import { Paper } from '@material-ui/core';
import { ObjectType } from '../../../../../../../../types/objectType';

export const CustomElevationPaper = (props: ObjectType) => (
  <Paper elevation={8} {...props} style={{ background: '#e6e6e6' }}
  />);
